import React from 'react';
import './JobCard.css';

const JobCard = ({ job }) => {
  return (
    <div className="job-card shadow">
      <div className="job-card-header">
        {job.urgent && <span className="urgent-badge">Urgently Hiring</span>}
        <h3>{job.title}</h3>
        <p className="company">{job.company}</p>
        <p className="location">📍 {job.location}</p>
        <p className="type">💼 {job.type}</p>
      </div>

      <div className="job-card-body">
        <p className="salary">💰 {job.salary}</p>
        <div className="perks">
          <span className="perk">🏠 {job.type === 'WFH' || job.type === 'Remote' ? 'Remote/WFH' : 'Onsite'}</span>
          <span className="perk">💰 Provident Fund</span>
        </div>
      </div>

      <div className="job-card-footer">
        <p className="posted">🕒 Posted: {job.posted}</p>
        <button className="apply-button">🚀 Apply Now</button>
      </div>
    </div>
  );
};

export default JobCard;
